module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/3/3-7ebd6c6cd63545201ec502c3dda0b65b.jpg";